<template>
	<div>
		<div v-if="loading"></div>
		<div v-else>
			<div v-if="error">{{ error }}</div>
			<div v-else>
				<div v-if="html != null" v-html="html"></div>
				<div v-for="article in articles" :key="article.title" class="article-card small fixed">
					<div class="uk-grid-collapse" uk-grid>
						<div class="uk-width-1-3 left-col">
							<a :href="article.link">
								<img v-if="article.imageUrl" :src="article.imageUrl" class="uk-width-auto uk-border-rounded" />
							</a>
						</div>
						<div class="uk-width-expand right-col">
							<div class="uk-padding-small-left uk-inline">
								<span v-if="article.category" class="uk-label category uk-padding-xxsmall">
									{{ article.category }}
								</span>
								<h1 class="title"><a :href="article.link">{{ article.title }}</a></h1>
								<p v-if="article.description && showDescription" class="description uk-margin-remove uk-visible@s">
									{{ article.description }}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { ref, onMounted } from 'vue'
import axios from 'axios'

export default {
	props: {
		feedUrl: {
			type: String,
			required: true
		},
		type: {
			type: String,
			default: 'rss' // client or server 
		},
		limit: {
			type: Number,
			required: false,
			default: 5
		},
		showDescription: {
			type: Boolean,
			required: false,
			default: true	
		}
	},

	setup(props) {
		const loading = ref(true)
		const error = ref(null)
		const articles = ref([])
		const html = ref(null)
		
		const parseXmlData = (data) => {
			const parser = new DOMParser()
			const xmlDoc = parser.parseFromString(data, "text/xml")

			const items = xmlDoc.querySelectorAll('item')
			for(let i = 0; i < Math.min(props.limit, items.length); i++) {
				articles.value.push({
					title: items[i].querySelector('title').textContent,
					description: items[i].querySelector('description').textContent,
					link: items[i].querySelector('link').textContent,
					category: (items[i].querySelector('category')) ? items[i].querySelector('category').textContent : null,
					imageUrl: items[i].querySelector('enclosure') ? items[i].querySelector('enclosure').getAttribute('url') : null			
				})
			}
		}

		onMounted(async () => {
			try {
				
				// Get data
				const { data } = await axios.get(props.feedUrl)
				
				// Parse directly
				if(props.type == 'rss') {
					parseXmlData(data)
				} else {
					
					// Set html content
					html.value = data
				}
				
				loading.value = false
			} catch (err) {
				error.value = 'Artikelen konden niet geladen worden.'
				loading.value = false
			}
		})

		return {
			loading,
			error,
			articles,
			html
		}
	}
}
</script>

<style scoped>
/* Add your styles here */
</style>
